import * as actions from "store/actions/user";
import IUser from "Types/User";

export interface UserState {
	items: IUser[];
	filter: any[];
	pages: any;
	count: number;
	loading: boolean;
	errors: any;
}

const initialState: UserState = {
	items: [],
	filter: [],
	pages: null,
	count: 0,
	loading: false,
	errors: {}
};

const reducer = function (state = initialState, { type, payload }: any) {
	switch (type) {
		case actions.GET_USERS: {
			return {
				...state,
				loading: true,
				errors: initialState.errors
			};
		}
		case actions.GET_USERS_SUCCESS: {
			return {
				...state,
				items: payload || [],
				loading: false
			};
		}
		case actions.GET_USERS_FAILED: {
			return {
				...state,
				loading: false,
				errors: payload
			};
		}
		case actions.SET_VALUE:
			return {
				...state,
				...payload
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState
			};
		default: {
			return state;
		}
	}
};

export default reducer;
